export default __webpack_public_path__ + "static/media/insight3.6d264fa1.png";